import React from 'react'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import PropTypes from 'prop-types';

export const ExportCSV = ({ csvData, fileName, disabled }) => {

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = (csvData, fileName) => {

        if (csvData) {
            if(Array.isArray(csvData)){
                const ws = XLSX.utils.json_to_sheet(csvData);
                const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });
                FileSaver.saveAs(data, fileName + fileExtension);
            }else{
                // const newCsvData = Object.entries(csvData)
                const values = Object.values(csvData);
                const columnNameList = Object.keys(csvData)


                let r = [];
                if (Array.isArray(values[0]))
                    r = values[0].map((_, i) =>  values.map((val) => val[i]));
                else
                    r = [values];

                r.unshift(columnNameList);
                
                const ws = XLSX.utils.aoa_to_sheet(r);
                const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });
                FileSaver.saveAs(data, fileName + fileExtension);
                
            }
  
        }
    }

    return (
        <button
            disabled={!!disabled}
            className={`flex items-center gap-1.5 px-4 py-2 text-sm rounded-lg font-medium transition
                ${disabled ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-green-600 text-white hover:bg-green-700'}`}
            onClick={() => exportToCSV(csvData, fileName)}
        >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Export
        </button>
    )
}

ExportCSV.propTypes = {
  csvData: PropTypes.any,
  fileName: PropTypes.string,
  disabled: PropTypes.bool,
};
